import React, { FunctionComponent } from 'react';
import { View, Text, Progress } from '@upstox/upstox-ui';
import * as css from './IPOTimeline.style';
import IPOTimeLineItem from './IPOTimelineItem';
import moment from 'dayjs';
import { isPastTimeline } from '../helpers';
import { REFUND_TEXT } from './constants';
import useMediaQuery from '../../../hooks/useMediaQuery';

type Props = {
  biddingStartDate: string;
  biddingEndDate: string;
  allotmentDate: string;
  refundInitiationDate: string;
  dematTransferDate: string;
  listingDate: string;
  isSeoApp?: boolean;
};

const getFormattedDate = (date) =>
  date ? `${moment(date).format('DD MMM ‘YY')}` : '--';

const IPOTimeLine: FunctionComponent<Props> = ({
  biddingStartDate,
  biddingEndDate,
  allotmentDate,
  refundInitiationDate,
  dematTransferDate,
  listingDate,
  isSeoApp = false,
}) => {
  const ipoTimeLineItems = [
    {
      label: 'Bidding starts',
      value: getFormattedDate(biddingStartDate),
      status: biddingStartDate && isPastTimeline(biddingStartDate),
    },
    {
      label: 'Bidding ends',
      value: getFormattedDate(biddingEndDate),
      status: biddingEndDate && isPastTimeline(biddingEndDate, false),
    },
    {
      label: 'Allotment finalisation*',
      value: getFormattedDate(allotmentDate),
      status: allotmentDate && isPastTimeline(allotmentDate),
    },
    {
      label: 'Refund initiation*',
      value: getFormattedDate(refundInitiationDate),
      status: refundInitiationDate && isPastTimeline(refundInitiationDate),
    },
    {
      label: 'Demat transfer',
      value: getFormattedDate(dematTransferDate),
      status: dematTransferDate && isPastTimeline(dematTransferDate),
    },
    {
      label: 'Listing',
      value: getFormattedDate(listingDate),
      status: listingDate && isPastTimeline(listingDate),
    },
  ];
  const ipoStageCount = ipoTimeLineItems.reduce(
    (count, item) => (item.status ? count + 1 : count),
    0,
  );
  const progressBarPercent = parseInt(((ipoStageCount / 6) * 100).toFixed(2));
  const renderTimeLineItems = () => {
    return ipoTimeLineItems.map((item) => (
      <IPOTimeLineItem
        key={item.label}
        label={item.label}
        value={item.value}
        status={item.status}
        isSeoApp={isSeoApp}
      />
    ));
  };
  const isVertical = useMediaQuery(768);

  return (
    <View flexDirection="column">
      {isSeoApp ? (
        <View flexDirection="column" css={css.timeLineCardContainer}>
          <Text variant="bodyBold" size="l" color="background.upstoxLogo">
            IPO Timeline
          </Text>
          <View flexDirection="column" css={css.timeLineContainer}>
            <Progress
              min={0}
              max={100}
              value={progressBarPercent}
              progressBg="#eeebe6"
              progressColor="#000000"
              isVertical={isVertical}
            />
            <View justifyContent="space-between" css={css.timelineItemWrapper}>
              {renderTimeLineItems()}
            </View>
          </View>
        </View>
      ) : (
        <View flexDirection="column" css={css.timelineWrapper}>
          {renderTimeLineItems()}
        </View>
      )}
      <View css={css.notes}>
        <Text variant="meta" lineHeight="xl">
          {REFUND_TEXT}
        </Text>
      </View>
    </View>
  );
};

export default IPOTimeLine;
